import { render, staticRenderFns } from "./factoryList.vue?vue&type=template&id=496a8cac&"
import script from "./factoryList.vue?vue&type=script&lang=js&"
export * from "./factoryList.vue?vue&type=script&lang=js&"
import style0 from "./factoryList.vue?vue&type=style&index=0&id=496a8cac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports